import React, { useContext } from 'react';
import { ICustomMediaSettingsForUpdate } from 'types';
import { IStyleContext, StyleContext } from '../../styleState/styleContext';
import MediaGroup from './components/MediaGroup';
import classNames from 'classnames';
import style from './MediaFields.module.scss';

interface IMediaFields {
	data: ICustomMediaSettingsForUpdate;
}

const MediaFields: React.FC<IMediaFields> = ({ data }) => {
	const { selectedLanguage } = useContext<IStyleContext>(StyleContext);
	const containerClasses = classNames(style.container, { [style.visible]: data.languageId === selectedLanguage });

	return (
		<div className={containerClasses} data-test="MediaFields">
			{data.groups.map((el) => (
				<MediaGroup data={el} languageId={data.languageId} key={el.id} />
			))}
		</div>
	);
};

export default React.memo(MediaFields);
